module.exports = __webpack_public_path__ + "img/2034.4307ce16.png";